module.exports = {
      id: "default-author-image-usage",
      viewBox: "0 0 48 48",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#default-author-image",
      toString: function () {
        return this.url;
      }
    }